import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'

import http from 'utils/request'
import './utils/components'
import './ant-design-vue'

import htmlToPdf from 'utils/htmlToPdf'
Vue.prototype.$http = http
Vue.use(htmlToPdf)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
